import { render, staticRenderFns } from "./FinishDialog.vue?vue&type=template&id=3ddda464&scoped=true"
import script from "./FinishDialog.vue?vue&type=script&lang=ts"
export * from "./FinishDialog.vue?vue&type=script&lang=ts"
import style0 from "./FinishDialog.vue?vue&type=style&index=0&id=3ddda464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddda464",
  null
  
)

export default component.exports